import SatoshiWoff from "./Satoshi-Regular.woff";
import SatoshiBoldWoff from "./Satoshi-Bold.woff";
import SatoshiBlackWoff from "./Satoshi-Black.woff";
import SatoshiBlackItalicWoff from "./Satoshi-BlackItalic.woff";
import SatoshiBoldItalicWoff from "./Satoshi-BoldItalic.woff";
import SatoshiItalicWoff from "./Satoshi-Italic.woff";
import SatoshiLightWoff from "./Satoshi-Light.woff";
import SatoshiLightItalicWoff from "./Satoshi-LightItalic.woff";
import SatoshiMediumWoff from "./Satoshi-Medium.woff";
import SatoshiMediumItalicWoff from "./Satoshi-Bold.woff";
import SatoshiVariableWoff from "./Satoshi-Variable.woff";
import SatoshiVariableItalicWoff from "./Satoshi-VariableItalic.woff";

export const satoshi = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 400,
  src: `
      url(${SatoshiWoff}) format('woff')
    `,
};

export const satoshiBold = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 700,
  src: `
      url(${SatoshiBoldWoff}) format('woff')
    `,
};

export const satoshiBlack = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 900,
  src: `
      url(${SatoshiBlackWoff}) format('woff')
    `,
};

export const satoshiBlackItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 900,
  src: `
      url(${SatoshiBlackItalicWoff}) format('woff')
    `,
};

export const satoshiItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 400,
  src: `
      url(${SatoshiItalicWoff}) format('woff')
    `,
};

export const satoshiBoldItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 700,
  src: `
      url(${SatoshiBoldItalicWoff}) format('woff')
    `,
};

export const satoshiLight = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 300,
  src: `
      url(${SatoshiLightWoff}) format('woff')
    `,
};

export const satoshiLightItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 300,
  src: `
      url(${SatoshiLightItalicWoff}) format('woff')
    `,
};

export const satoshiMedium = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 500,
  src: `
      url(${SatoshiMediumWoff}) format('woff')
    `,
};

export const satoshiMediumItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 500,
  src: `
      url(${SatoshiMediumItalicWoff}) format('woff')
    `,
};

export const satoshiVariable = {
  fontFamily: "Satoshi",
  fontStyle: "normal",
  fontDisplay: "block",
  fontWeight: 300,
  src: `
      url(${SatoshiVariableWoff}) format('woff')
    `,
};

export const satoshiVariableItalic = {
  fontFamily: "Satoshi",
  fontStyle: "italic",
  fontDisplay: "block",
  fontWeight: 300,
  src: `
      url(${SatoshiVariableItalicWoff}) format('woff')
    `,
};
